<template>
  <div id="app">
    <div v-if="$store.state.appInfo.site_state == 1">
      <div class="meLoading" v-if="loading">
        <van-loading size="24px" vertical color="#0094ff" text-color="#0094ff">加载中...</van-loading>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.name" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.name" />
    </div>
    <div v-if="$store.state.appInfo.site_state == 0" style="box-sizing: border-box; padding: 30px; fong-size: 26px">{{ $store.state.appInfo.repair_tips }}</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      daoTime: null,
      loading: false,
      pid: '',
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;

    that.getApp();
    that.getGameList();

    if (sessionStorage.getItem('token')) {
      that.openDaoTime();
      that.getUserInfo();
    }
    if (query.pid) {
      that.pid = query.pid;
      that.$router.push({ path: `/login?type=1&pid=${query.pid}` });
    }
    // that.getVisitUrl();  // 注释掉 getVisitUrl 调用
  },
  mounted() {
    // --- UniApp WebView Detection (Moved and Enhanced) ---
    let isUniappEnv = false;
    // 1. Check for global objects
    if (typeof window.__uniapp !== 'undefined' || typeof window.plus !== 'undefined') {
        console.log('UniApp WebView detected via global object (__uniapp or plus).');
        isUniappEnv = true;
    } else {
        // 2. Fallback: Check User Agent for specific strings
        const ua = navigator.userAgent.toLowerCase();
        if (ua.includes('uni-app') || ua.includes('html5plus')) {
            console.log('UniApp WebView detected via User Agent (uni-app or html5plus).');
            isUniappEnv = true;
        }
    }

    // If detected by either method
    if (isUniappEnv) {
        console.log('Applying UniApp environment settings: Bypassing Entry Page and updating store.');
        // Check if entry page is currently shown before potentially changing state
        // This prevents unnecessary updates if already bypassed
        if (this.showEntryPage) { 
            this.showEntryPage = false; // Bypass EntryPage
            localStorage.setItem('entryPageShown', 'true'); 
        }
        // Always update the store state if in UniApp env
        this.$store.commit('SET_IS_UNIAPP_WEBVIEW', true);
    }
    // --- End UniApp WebView Detection ---

    // Existing mounted logic (if any) can go here or remain if separated
  },
  methods: {
    getVisitUrl() {
      let that = this;
      that.$apiFun
        .get('/api/getVisitUrl', {})
        .then(res => {
          if (res.code == 200) {
            let url = that.pid ? res.data.url + 'register?pid=' + that.pid : res.data.url;
            // Comment out the redirection to prevent switching to PC version
            // window.open(url, '_self'); 
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    // 获取游戏列表
    getGameList() {
      let that = this;

      // that.$apiFun.get('/api/game/list', { category: '' }).then(res => {
      //   if (res.code == 200) {
      //     let list = res.data;
      //     let realbetList = [];
      //     let jokerList = [];
      //     let gamingList = [];
      //     let sportList = [];
      //     let lotteryList = [];
      //     let conciseList = [];
      //     list.forEach(el => {
      //       if (el.category_id == 'realbet' && el.app_state == 1) {
      //         realbetList.push(el);
      //       }
      //       if (el.category_id == 'joker' && el.app_state == 1) {
      //         jokerList.push(el);
      //       }
      //       if (el.category_id == 'gaming' && el.app_state == 1) {
      //         gamingList.push(el);
      //       }
      //       if (el.category_id == 'sport' && el.app_state == 1) {
      //         sportList.push(el);
      //       }
      //       if (el.category_id == 'lottery' && el.app_state == 1) {
      //         lotteryList.push(el);
      //       }
      //       if (el.category_id == 'concise' && el.app_state == 1) {
      //         conciseList.push(el);
      //       }

      //       localStorage.setItem('realbetList', JSON.stringify(realbetList));
      //       localStorage.setItem('jokerList', JSON.stringify(jokerList));
      //       localStorage.setItem('gamingList', JSON.stringify(gamingList));
      //       localStorage.setItem('sportList', JSON.stringify(sportList));
      //       localStorage.setItem('lotteryList', JSON.stringify(lotteryList));
      //       localStorage.setItem('conciseList', JSON.stringify(conciseList));
      //       that.$store.commit('changGameList');
      //     });
      //   }
      // });
    },
    // 获取app
    getApp() {
      let that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
    // 退出登录
    outLogin() {
      let that = this;

      that.$dialog
        .confirm({
          title: '提示',
          message: '您确定要退出登录吗?',
          confirmButtonText:'确认退出',
          cancelButtonText:'我点错了',
          className:'btnLoginOut'
        })
        .then(() => {
          that.showLoading();

          that.$apiFun
            .post('/api/logoff', {})
            .then(res => {
              localStorage.clear();
              sessionStorage.clear();
              that.$store.commit('changUserInfo');
              that.$store.commit('changToken');
              that.closeDaoTime();
              that.hideLoading();
              that.$router.push({ path: '/login' });
            })
            .catch(() => {
              localStorage.clear();
              sessionStorage.clear();
              // that.$cookies.remove('token' )/
              that.$store.commit('changUserInfo');
              that.$store.commit('changToken');
              that.closeDaoTime();
              that.hideLoading();
              that.$router.push({ path: '/login' });
            });
        })
        .catch(() => {});
    },
    // 打开游戏
    openGamePage(name, gameId, code) {
      let that = this;
      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
      if (!token) {
        that.showTost(0, '请登录！');
        that.$router.push('/login');
        return;
      }
      that.goNav(`/gamePage?name=${name}&gameId=${gameId}&code=${code}`);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();
      document.execCommand('copy');
      this.showTost(1, '复制成功！');
    },
    goNav(url) {
      let that = this;

      if (url == '/hongbao' || url == '/transfer') {
        if (!that.$store.state.token) {
          that.$dialog
            .confirm({
              message: '精彩内容等你来体验，快来登录吧！',
            })
            .then(() => {
              this.$router.push({ path: '/login' });
            });

          return;
        }
        if (url == '/hongbao' && that.$store.state.appInfo.redpacket_switch == 0) {
          that.showTost(0, '红包已关闭');
          return;
        }
      }
      if (url == this.$route.fullPath) {
        that.showTost(0, '已在当前页面！');
        return;
      }

      this.$router.push({ path: url });
    },
    closeDaoTime() {
      let that = this;
      if (that.daoTime != null) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
    // 不刷新页面更新用户余额
    getBalance() {
      let that = this;
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          if (res.code == 401) {
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.closeDaoTime();
            that.$router.push({ path: '/login' });
          }
        })
        .catch(res => {});
    },
    openDaoTime() {
      let that = this;
      that.daoTime = setInterval(() => {
        that.getBalance();
      }, 60000);
    },
    // 不刷新页面跟新用户信息
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
          
          // 执行一键回收，无论成功失败都刷新余额
          that.$apiFun.post('/api/transall', {})
            .then(() => {
              // 一键回收成功，刷新余额
              that.refreshBalance();
            })
            .catch(() => {
              // 一键回收失败，也刷新余额
              that.refreshBalance();
            });
        }
      });
    },
    // 刷新余额的方法
    refreshBalance() {
      let that = this;
      that.$apiFun.post('/api/balance', {}).then(res => {
        if (res.code == 200) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo'));
          userInfo.balance = res.data.balance;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
        }
      }).catch(() => {});
    },
    // 刷新页面更新信息
    getUserInfoShowLoding() {
      let that = this;
      that.showLoading();
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
          that.hideLoading();
        }
      });
    },
    // 获取代理
    getAgentLoginUrl() {
      let that = this;
      that.$parent.goNav(`/gamePage?dailiD=1`);
    },
    openKefu() {
      let that = this;
      that.goNav(`/kefu`);
    },
    showTost(type, title) {
      let str = type ? 'success' : 'danger';
      this.$notify({ type: str, message: title });
    },
    showLoading() {
      // this.loading = true; // Commented out to disable global loading
    },
    hideLoading() {
      // this.loading = false; // Commented out to disable global loading
    },
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>

<style>
/* @import '../static/css/registermember.css';
 @import '../static/css/registermember.css';
 @import '../static/css/registermember.css';
 @import '../static/css/registermember.css'; */
#app{
  max-width:412px;
			margin: 0 auto;
      position: relative;
}
.van-tabbar-item__text{
  position: relative;
}
.meLoading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
}
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #866638;
}

.step .van-tab--active {
  color: #fff;
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUwIiBoZWlnaHQ9IjM2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0wIDB2MzZoMjQwLjgzN0wyNTAgMThsLTkuMTYzLTE4eiIgZmlsbD0iIzA2OUI3MSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+) no-repeat 100% / cover;
}

.step .van-tabs--line .van-tabs__wrap {
  height: 27px;
}
.metransRecord .van-tabs__nav--card .van-tab.van-tab--active {
  color: #fff;
  background-color: #866638;
  border-radius: 22px;
}
.metransRecord .van-tabs__nav--card {
  border: none;
}
.metransRecord .van-tabs__nav--card .van-tab {
  border: none;
}
.metransRecord .van-tabs__nav--card .van-tab {
  color: #000;
}

/* 页眉 */

.pageTop {
  background-color: #FFF;
  color: rgb(0, 0, 0);
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  height: 40px;
  line-height: 40px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 200;
}

.acts .van-tabs__line {
  background-color: #866638 !important;
}
.acts .van-tab--active {
  color: #866638 !important;
}

.van-nav-bar .van-icon {
  color: #000;
}
.van-nav-bar {
  background-color: #866638;
  border-bottom: 1px solid #e3e3e3;
}
.van-nav-bar__arrow {
  font-size: 24px;
}
.van-nav-bar__title {
}

.bancgs {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 30px;
  opacity: 0.8;
  z-index: 200;
}
p {
  margin-block-start: 5px !important;
  margin-block-end: 5px !important;
}
.inputsw {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}
.van-tab--active {
  color: #866638;
}
.van-tabs__line {
  background-color: #866638;
}
.van-cell {
  padding: 5px 8px;
}
.sdg .van-field__label {
  width: 0.2rem;
}
[class*='van-hairline']:after {
  border: none;
}
.sdgg .van-popup {
  border-radius: 15px 15px 0 0;
}

.stddss .van-field__control {
  font-size: 0.5rem;
}

.van-button--info {
  color: #fff;
  background-color: #866638;
  border: 1px solid #866638;
}
.van-dialog__confirm{
  margin-bottom: 10px;
    border: 1px solid #866638;
    color: #866638;
    width: 60%;
    height:36px;
    border-radius: 6px;
}
.van-dialog__cancel{
    border: 1px solid #866638;
    color: #fff;
    background: #866638;
    width: 60%;
    height:36px;
    border-radius: 6px;
}
.van-dialog__header{
  padding-top: 16px;
  font-size: 22px;
}

.van-tabbar--fixed{
  position: sticky!important;
}
/* .domainModal_domainView__FWCzg,
.domainModal_domainView__FWCzg .domainModal_mask__24Y2m{
  left: 50%!important;
  transform: translate(-50%,0);
  width:560px!important;
}
.domainModal_content__1nBgc{
 left: 50%!important;
  transform: translate(-50%,0);
} */
/* .topsa .van-tab{
  flex:.1!important
}
.topsa .van-tabs__line{
  height: 2px!important;
} */
.van-dialog__footer{
  justify-content: space-around;
}
.van-dialog__confirm,.van-dialog__cancel{
  width: 140px;
  flex: inherit;
}

#app {
  -webkit-overflow-scrolling: touch!important;; /* 启用 iOS 平滑滚动 */
  overscroll-behavior-y: contain!important;; /* 阻止边界弹性效果 */
}
.domainModal_content__1nBgc{
  border-radius: 8px!important;
}
.domainModal_middle__3gQPm{
      border-top-left-radius: 8px!important;
    border-top-right-radius: 8px!important;
}

.van-overlay{
  width: 100%;
  max-width: 412px;
  transform: translate(-50%,-50%);
  left: 50%!important;
  top: 50%;
}
.van-popup{
  position: absolute!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue